import { axiosInstance } from '~/services';

import type {
  TypeGetOwnerManagerExistsOwnerLoginIdParams,
  TypeGetOwnerManagerExistsOwnerLoginIdResponse,
} from '~/types/vender.types';

/**
 * [화주사정보관리 > 화주사정보] 화주사 담당자 로그인 ID 중복 조회
 */
const useGetOwnerManagerExistsOwnerLoginId = () => {
  const endPoint = '/api-owner/owner-manager/exists';

  const getOwnerManagerExistsOwnerLoginId = async ({ ownerLoginId }: TypeGetOwnerManagerExistsOwnerLoginIdParams) => {
    return axiosInstance
      .get<TypeGetOwnerManagerExistsOwnerLoginIdResponse>(`${endPoint}/${ownerLoginId}`)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error) => {
        throw error;
      });
  };

  return { getOwnerManagerExistsOwnerLoginId };
};

export default useGetOwnerManagerExistsOwnerLoginId;
